// THE firm-capacity pill, one author (ruled Jun 2026).
//
// Before this, the pill read `firm_capacity_buildup.status`, which never
// consults `n1_status`: a plant that met its firm target but failed N-1 — the
// largest dispatchable unit out and the site short — printed FIRM CAPACITY OK
// in green. Under a small-unit ladder that combination is reachable on
// ordinary sites, so the pill has to say it.
//
// Display only. The engine's `status` and `n1_status` are untouched; this is
// the one place that turns the pair into a colour and a sentence, and Results,
// Adjust Mix and the PDF all read it (the PDF through the Python twin in
// `report_v3/i18n.firm_pill`).
// The status is read STRICTLY, like the Python twin: an ABSENT verdict is not
// a green one. `{ tone: null }` means "no pill" and the caller renders none.
export function firmPill(model) {
  const b = (model && model.firm_capacity_buildup) || null;
  const base = b && b.status;
  if (!base) return { tone: null, key: null, n1Fail: false };
  if (base === "red") return { tone: "red", key: "results.firm_status_red", n1Fail: false };
  if (b.n1_status === "fail") {
    return { tone: "amber", key: "results.firm_status_n1_fail", n1Fail: true };
  }
  return { tone: base, key: `results.firm_status_${base}`, n1Fail: false };
}

// The tick on the firm tile. Green only when firm is met AND N-1 passes. With
// no build-up to read, fall back to the engine's own `firm_capacity_ok` —
// a field that is present, not a default invented here.
export function firmTileOk(model) {
  const p = firmPill(model);
  if (p.tone === null) return (model && model.firm_capacity_ok) !== false;
  return p.tone === "green";
}

export const FIRM_PILL_BG = { green: "#D1FAE5", amber: "#FEF3C7", red: "#FEE2E2" };
export const FIRM_PILL_FG = { green: "#065F46", amber: "#92400E", red: "#7F1D1D" };
